import mitt from 'mitt'

type ChannelProps = {
  showNearestResults: () => void
  footerInView: boolean
}

export const mapEventChannel = mitt<ChannelProps>()

/**
 * Emits the event that is registered at the useMap hook
 * Makes double zoom-out and performs the area search
 */
export const showNearestResults = () => {
  mapEventChannel.emit('showNearestResults')
}
